module.exports = __webpack_public_path__ + "media/newstyle/images/esboco-9c4a239456774d49a89eba3b28b3a1a0.png";